import Vue from "vue";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import InfiniteLoading from "vue-infinite-loading";//// https://peachscript.github.io/vue-infinite-loading/guide/configure-plugin-opts.html#props-settings
import vuescroll from "vuescroll"
import DateRangePicker from 'vue2-daterange-picker' //https://innologica.github.io/vue2-daterange-picker/#installation
import SmartTable from "vuejs-smart-table"; //https://tochoromero.github.io/vuejs-smart-table/

import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import ErrorReporter, { IErrorReport } from "./utilities/ErrorReporter";

import "@/utilities/CustomFilters";

// CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-pro/css/all.css"
import "toastr/build/toastr.css";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import "./css/site.css";

Vue.use(Vuelidate as any); // eslint-disable-line @typescript-eslint/no-explicit-any

Vue.use(BootstrapVue);

Vue.use(InfiniteLoading, {
    props: { spinner: "spiral" },
    slots: { noMore: "no more items", noResults: "" }
});

Vue.use(DateRangePicker);
Vue.use(vuescroll);
Vue.use(SmartTable);

import Blank from "./layouts/Blank.vue";
import SignedOut from "./layouts/SignedOut.vue";
import SignedIn from "./layouts/SignedIn.vue";
import dirtyness from "@/utilities/Dirtyness";

Vue.component("blank-layout", Blank);
Vue.component("signed-out-layout", SignedOut);
Vue.component("signed-in-layout", SignedIn);

Vue.config.productionTip = false;

Vue.config.errorHandler = ErrorReporter.vueErrorHandler;
window.onerror = ErrorReporter.windowErrorHandler;

// dirty-check - leaving page
window.addEventListener("beforeunload", (event?: Event) => {
    if (!event) {
        event = window.event;
    }
    if (dirtyness.isDirty) {
        if (event) {
            event.preventDefault();
            event.returnValue = true;
        }
        // I don't think messages like this are supported in modern browsers but...
        return "It looks like you have not saved your changes.";
    }
    else {
        if (event) {
            // From MDN docs: https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
            // the absence of a returnValue property on the event will guarantee the browser unload happens
            delete (event as any)["returnValue"];
        }
        // no real point in calling reset() since we're leaving the site but might as well...
        dirtyness.reset();
        return undefined;
    }
});
//
// -- Mount the application!
//

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");